import React from "react";
import Login from "./login/Login";
import EventList from "./event";
import useIsLoggedIn from "../hooks/useIsLoggedIn";

export default function Home() {
  const isLoggedIn = useIsLoggedIn();
  return !isLoggedIn ? <Login /> : <EventList />;
}
